import { render, staticRenderFns } from "./CountrySelectItem.vue?vue&type=template&id=08848a54&scoped=true&"
import script from "./CountrySelectItem.vue?vue&type=script&lang=ts&"
export * from "./CountrySelectItem.vue?vue&type=script&lang=ts&"
import style0 from "./CountrySelectItem.vue?vue&type=style&index=0&id=08848a54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08848a54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VLabel,VSelect})
